<template>
  <div>
    <NavigationBar />
    <div v-if="!loading">
      <div class="uk-section">
        <div class="uk-container ">
          <h3 class="uk-text-center uk-text-bold">Event</h3>
          <div v-if="!loading" class=""  uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: false;">
            <!-- DESKTOP -->
            <div class="uk-visible@s uk-grid uk-grid-match" uk-grid>
              <div class="uk-width-1-2@s uk-text-center" v-for="event in events">
                <div class="uk-flex-middle cursor uk-box-shadow-large uk-grid-collapse" uk-grid>
                  <div class="uk-width-1-2@m">
                    <h3 class="uk-card-title">{{ event.name }}</h3>
                    <!-- <p class="uk-text-bold">{{ event.title }}</p> -->
                    <p>{{ event.location }}</p>
                    <p class="uk-margin-remove uk-text-small uk-text-muted">{{ event.date }}</p>
                  </div>
                  <div class="uk-width-1-2@m uk-flex-first">
                    <iframe style="width: 100%; height: 500px;"
                    :src="event.link"
                    frameborder="0"
                    allow="autoplay; encrypted-media"
                    allowfullscreen
                  ></iframe>
                  </div>
                </div>
              </div>
              <!-- <div class="uk-text-center uk-width-1-4@s" v-for="event in influencerData">
                <div class="uk-flex-middle cursor uk-box-shadow-large uk-grid-collapse" uk-grid>
                  <div class="">
                    <iframe style="width: 100%; height: 400px;"
                      :src="event.src"
                      frameborder="0"
                      allow="autoplay; encrypted-media"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
              </div> -->
            </div>

            <!-- MOBILE -->
            <div class="uk-hidden@s uk-grid-small" uk-grid>
              <div class="uk-text-center" v-for="event in events">
                <div class="uk-flex-middle cursor uk-box-shadow-large uk-grid-collapse" uk-grid>
                  <div class="uk-width-1-2 uk-padding-small">
                    <br/>
                    <p class="uk-text-bold uk-margin-remove font-description">{{ event.name }}</p>
                    <p class=" uk-margin-remove ">{{ event.title }}</p>
                    <br/>
                    <p class="uk-margin-remove uk-text-small">{{ event.location }}</p>
                    <p class="uk-margin-remove uk-text-small">{{ event.date }}</p>
                  </div>
                  <div class="uk-width-1-2 uk-flex-first">
                    <iframe style="width: 100%; height: 290px;"
                      :src="event.src"
                      frameborder="0"
                      allow="autoplay; encrypted-media"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
              </div>
              <!-- <div class="uk-text-center uk-width-1-2" v-for="event in influencerData">
                <div class="uk-flex-middle cursor uk-box-shadow-large uk-grid-collapse" uk-grid>
                  <div class="">
                    <iframe style="width: 100%; height: 290px;"
                      :src="event.src"
                      frameborder="0"
                      allow="autoplay; encrypted-media"
                      allowfullscreen
                    ></iframe>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <div
            class="uk-flex uk-flex-center uk-flex-middle"
            style="height: 100%"
            v-else
          >
            <div uk-spinner></div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="uk-section" style="height: 70vh">
      <div class="uk-container" style="height: 100%">
        <div
          class="uk-flex uk-flex-center uk-flex-middle"
          style="height: 100%"
        >
          <div uk-spinner></div>
        </div>
      </div>
    </div>
    <h1 class="uk-heading-divider"></h1>
    <Footer />
  </div>
</template>

<script>
import NavigationBar from "@/components/NavigationBar.vue";
import Footer from "@/components/Footer.vue";
import NavbarMobileComponent from "@/components/NavbarMobileComponent.vue";
import axios from "axios";
import { mapGetters } from "vuex";


export default {
  name: "productView",
  components: {
    NavigationBar,
    Footer,
    NavbarMobileComponent,
  },
  data() {
    return {
      data: {},
      loading: false,
      events: [],
      eventData: [
        {
          title: 'Event Indocomtech',
          location: 'ICE BSD',
          name: 'Speaker Roomi',
          date: '25-29 Oct 2023',
          src: 'https://www.youtube.com/embed/5aSQd2cKxjw?rel=0&autoplay=1&mute=1&loop=1&playlist=5aSQd2cKxjw'
        },
        {
          title: 'Electronic Expo',
          location: 'Grand Indonesia',
          name: 'Standing Hair Dryer',
          date: '11-22 Sept 2024',
          src: 'https://www.youtube.com/embed/N3KaUJ_-OJI?rel=0&autoplay=1&mute=1&loop=1&playlist=N3KaUJ_-OJI'
        }
      ],
      influencerData: [
        {
          title: 'Electronic Expo',
          location: 'Grand Indonesia',
          name: 'Mellyshuwanty',
          date: '11-22 Sept 2024',
          src: 'https://www.youtube.com/embed/8k7HXaGjUDU?rel=0&mute=1&loop=1'
        },
        {
          title: 'Electronic Expo',
          location: 'Grand Indonesia',
          name: 'Angelltamara',
          date: '11-22 Sept 2024',
          src: 'https://www.youtube.com/embed/6Ed5LBnsgRc?rel=0&mute=1&loop=1'
        },
        {
          title: 'Electronic Expo',
          location: 'Grand Indonesia',
          name: 'BrendaPanja',
          date: '11-22 Sept 2024',
          src: 'https://www.youtube.com/embed/BODFp55uxF4?rel=0&mute=1&loop=1'
        },
        {
          title: 'Electronic Expo',
          location: 'Grand Indonesia',
          name: 'vaalenzhang',
          date: '11-22 Sept 2024',
          src: 'https://www.youtube.com/embed/i0i_unxy-PA?rel=0&mute=1&loop=1'
        },
        // {
        //   title: 'Electronic Expo',
        //   location: 'Grand Indonesia',
        //   name: 'Bramrpa',
        //   date: '11-22 Sept 2024',
        //   src: 'https://www.youtube.com/embed/ozXdiy-YuXU?rel=0&mute=1&loop=1'
        // },
        // {
        //   title: 'Electronic Expo',
        //   location: 'Grand Indonesia',
        //   name: 'Aurelia shearen',
        //   date: '11-22 Sept 2024',
        //   src: 'https://www.youtube.com/embed/xwJYdG0Kd1s?rel=0&mute=1&loop=1'
        // },
        // {
        //   title: 'Electronic Expo',
        //   location: 'Grand Indonesia',
        //   name: 'Scharlieze',
        //   date: '11-22 Sept 2024',
        //   src: 'https://www.youtube.com/embed/FdlWOJu3oZs?rel=0&mute=1&loop=1'
        // },
        // {
        //   title: 'Electronic Expo',
        //   location: 'Grand Indonesia',
        //   name: 'Elika Boen',
        //   date: '11-22 Sept 2024',
        //   src: 'https://www.youtube.com/embed/GkcZbN2Y81g?rel=0&mute=1&loop=1'
        // },
        // {
        //   title: 'Electronic Expo',
        //   location: 'Grand Indonesia',
        //   name: 'Vienna elvira putri',
        //   date: '11-22 Sept 2024',
        //   src: 'https://www.youtube.com/embed/kOviTOvukTU?rel=0&mute=1&loop=1'
        // },
        // {
        //   title: 'Electronic Expo',
        //   location: 'Grand Indonesia',
        //   name: 'Ashley',
        //   date: '11-22 Sept 2024',
        //   src: 'https://www.youtube.com/embed/a4GvvWlC3ZI?rel=0&mute=1&loop=1'
        // },
        // {
        //   title: 'Electronic Expo',
        //   location: 'Grand Indonesia',
        //   name: 'Winnnueg',
        //   date: '11-22 Sept 2024',
        //   src: 'https://www.youtube.com/embed/T6lKnWVEnMs?rel=0&mute=1&loop=1'
        // },
        // {
        //   title: 'Electronic Expo',
        //   location: 'Grand Indonesia',
        //   name: 'Winda',
        //   date: '11-22 Sept 2024',
        //   src: 'https://www.youtube.com/embed/MzeiIfL8q5s?rel=0&mute=1&loop=1'
        // },
      ]
    };
  },
  computed: {
    ...mapGetters("auth", ["IS_AUTH", "GET_USER"]),
    isSmall() {
      return window.innerWidth < 960;
    },
    isVerySmall() {
      return window.innerWidth < 640;
    },
  },
  mounted() {
    this.getEvent()
  },
  methods: {
    replaceDashWithSpace(str) {
      return str.replace(/-/g, ' ');
    },
    getEvent() {
      axios.get(`${process.env.VUE_APP_API_ROOMI_URL}event`).then((res) => {
        if (res.status == 200) {
          const data = res.data;
          console.log(data)
          if (data.success) {
            this.events = data.data;
          }
        }
      });
    },
    setSeo() {
      let titlePage = this.category.toUpperCase() + " from Roomi";
      const siteDescription = this.data.description;
      document.title = titlePage;
      const check_meta = document.querySelectorAll("meta");
      let count_check = 0;
      check_meta.forEach((check) => {
        if (
          check.getAttribute("name") == "description" ||
          check.getAttribute("name") == "title" ||
          check.getAttribute("name") == "robots"
        ) {
          if (check.getAttribute("name") == "description") {
            check.setAttribute("content", "");
          }
          if (check.getAttribute("name") == "title") {
            check.setAttribute("content", titlePage);
          }
          if (check.getAttribute("name") == "robots") {
            check.setAttribute("content", "index, follow");
          }
          count_check = 1;
        }
      });
      if (count_check == 0) {
        var meta_description = document.createElement("meta");
        meta_description.setAttribute("name", "description");
        meta_description.setAttribute("content", siteDescription);
        document.getElementsByTagName("head")[0].appendChild(meta_description);
        const meta_title = document.createElement("meta");
        meta_title.setAttribute("name", "title");
        meta_title.setAttribute("content", titlePage);
        document.getElementsByTagName("head")[0].appendChild(meta_title);
        const meta_robots = document.createElement("meta");
        meta_robots.setAttribute("name", "robots");
        meta_robots.setAttribute("content", "index, follow");
        document.getElementsByTagName("head")[0].appendChild(meta_robots);
      }
    },
    openProduct(product){
			// this.$router.push({ path: `/product/${product}` });
      this.$router.push({ name: 'product-detail', params: { categoryid: this.replaceSpaceWithDash(this.category), productid: this.replaceSpaceWithDash(product) } })
		},
    replaceSpaceWithDash(str) {
      return str.replace(/\s+/g, "-").toLowerCase();;
    },
  },
};
</script>

<style lang="less" scoped>
</style>